export default {
  zh: {
    title: '查询重复的Accounts/Leads',
  },
  en: {
    title: 'Find Duplicates',
  },
};



// WEBPACK FOOTER //
// ./src/components/page/FindDuplicates/i18n.js